import { type SelectDataObject } from '../_tools/inputfields/Select';

const sIntAktivStatus: SelectDataObject[] = [
    { i: false, t: 'Nicht aktiv', icon: 'mdi:close', iconColor: 'error.main' },
    { i: true, t: 'Aktiv', icon: 'mdi:check', iconColor: 'success.main' },
];
export default sIntAktivStatus;
